import { Component, OnInit } from '@angular/core';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';
import { EndUserContextService } from '@app/shared/services/context/end-user-context.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'portal-end-user-call-center-sub-nav',
  templateUrl: './end-user-call-center-sub-nav.component.html',
  styles: [],
  standalone: false,
})
export class EndUserCallCenterSubNavComponent extends SubNavBaseComponent implements OnInit {
  public isCallCenterSupervisor$: Observable<boolean>;

  constructor(private endUserContextService: EndUserContextService) {
    super();
  }

  ngOnInit(): void {
    this.isCallCenterSupervisor$ = this.endUserContextService.callCenter.data$.pipe(
      map((callCenter) => callCenter?.isSupervisor === true),
      untilDestroyed(this)
    );
  }
}
